import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { getCurrentContext } from '../store';

export const useContextAwarePersistence = () => {
  const location = useLocation();
  const lastContextRef = useRef<string | null>(null);

  useEffect(() => {
    const currentContext = getCurrentContext();
    
    // If context changed, log the change
    if (lastContextRef.current && lastContextRef.current !== currentContext) {
      console.log(`🔄 Context changed from ${lastContextRef.current} to ${currentContext}`);
      console.log(`📝 Using separate session cookies for ${currentContext} context`);
      console.log(`✅ Admin and retail can now be accessed simultaneously`);
    } else if (!lastContextRef.current) {
      console.log(`🚀 Initial context: ${currentContext}`);
    }
    
    lastContextRef.current = currentContext;
  }, [location.pathname]);

  const currentContext = getCurrentContext();
  
  return {
    currentContext,
    isAdminContext: currentContext === 'auth-admin'
  };
}; 